<input
  class="w-full outline-hidden disabled:bg-white disabled:text-grey-500"
  [type]="field.type === 'password' ? 'password' : 'text'"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.data-test-id]="field.key"
  [attr.placeholder]="field.props.placeholder || null"
/>
